//#region src/components/Map/Root/Layers/utils.ts
function e(e = [], t = "MultiPolygon") {
	let n = (e) => Object.values(e).map((e) => Array.isArray(e[0]) ? n(e) : [e[1], e[0]]), r = n(e), i;
	if (t === "MultiPolygon") {
		let e = r[0]?.[0], t = r[0]?.[1];
		i = [[e || [], ...t || []]];
	} else i = r;
	return {
		type: "FeatureCollection",
		features: [{
			type: "Feature",
			geometry: {
				type: t,
				coordinates: i
			}
		}]
	};
}
function t(e = [], t = "MultiPolygon") {
	let n = (e) => Object.values(e).map((e) => Array.isArray(e[0]) ? n(e) : {
		lat: e[0],
		lng: e[1]
	}), r = n(e);
	if (t === "MultiPolygon") {
		let e = r, t = e[0]?.[0], n = e[0]?.[1];
		return [t || [], ...n || []];
	}
	return r;
}
//#endregion
export { t as n, e as t };
